import { type FC, useEffect, useRef } from 'react'

import { useDrop } from 'react-dnd'

import { classNames } from '@/utils/helpers'

interface Props {
  accept: string
  className?: string
}

export const ScrollTopDropTarget: FC<Props> = ({ accept, className }) => {
  const scrollTopDropRef = useRef(null)

  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  drop(scrollTopDropRef)

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isOver) {
        scrollUp()
      } else {
        clearInterval(intervalId)
      }
    }, 10)

    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId)
      }
    }
  }, [isOver])

  const scrollUp = () => {
    window.scrollBy(0, -100)
  }

  return (
    <div
      ref={scrollTopDropRef}
      className={classNames(
        'fixed left-0 right-0 top-0 z-50 h-[72px] w-full',
        !canDrop && 'pointer-events-none',
        className,
      )}
    />
  )
}
